export const DEFAULT_LOCALE = "pt-BR";
export const ENGLISH_LOCALE = "en-US";

export const SUPPORTED_LOCALES = [DEFAULT_LOCALE, ENGLISH_LOCALE];

export const LANGUAGE_OPTIONS = [
    { code: DEFAULT_LOCALE, short: "PT", label: "Português" },
    { code: ENGLISH_LOCALE, short: "EN", label: "English" },
];

const ROUTE_ALIASES = {
    "/plataforma": "/platform",
    "/precos": "/pricing",
    "/contato": "/contact",
    "/empresa": "/about",
    "/company": "/about",
    "/caso-de-uso": "/use-cases",
    "/casos-de-uso": "/use-cases",
    "/use-case": "/use-cases",
};

const LOCALIZED_PATHS = {
    [DEFAULT_LOCALE]: {
        "/pricing": "/precos",
        "/contact": "/contact",
    },
    [ENGLISH_LOCALE]: {
        "/precos": "/pricing",
        "/contato": "/contact",
        "/plataforma": "/platform",
        "/empresa": "/company",
        "/caso-de-uso": "/use-cases",
        "/casos-de-uso": "/use-cases",
        "/use-case": "/use-cases",
    },
};

export const getLocaleFromPathname = (pathname = "/") =>
    pathname.startsWith(`/${ENGLISH_LOCALE}`) ? ENGLISH_LOCALE : DEFAULT_LOCALE;

export const stripLocalePrefix = (path = "/") => {
    const stripped = path.replace(/^\/(?:pt-BR|en-US)(?=\/|$)/, "");
    return stripped || "/";
};

export const canonicalizePath = (path = "/") => {
    const cleanPath = stripLocalePrefix(path || "/").replace(/\/$/, "") || "/";
    return ROUTE_ALIASES[cleanPath] || cleanPath;
};

export const localizePath = (path = "/", targetLocale = DEFAULT_LOCALE) => {
    const canonical = canonicalizePath(path);
    const localized = LOCALIZED_PATHS[targetLocale]?.[canonical] || LOCALIZED_PATHS[targetLocale]?.[path];
    return localized || canonical;
};

export const withLocale = (path = "/", locale = DEFAULT_LOCALE) => {
    const nextPath = localizePath(path, locale);
    return `/${locale}${nextPath === "/" ? "" : nextPath}`;
};

export const buildLanguageHref = ({ pathname = "/", search = "", hash = "" }, targetLocale = DEFAULT_LOCALE) =>
    `${withLocale(pathname, targetLocale)}${search || ""}${hash || ""}`;

export const readLocaleValue = (value, locale = DEFAULT_LOCALE) => {
    if (!value || typeof value === "string") return value;
    return value[locale] || value[DEFAULT_LOCALE] || value[ENGLISH_LOCALE] || "";
};
